import config from '../config'
import axios from 'axios'
import filter from '@/filtres'
const serverRoot = config.serverRoot
var ajax = axios.create({
  baseURL: config.serverRoot,
  timeout: 600000
})
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.defaults.withCredentials = true
// Add a request interceptor
ajax.interceptors.request.use(function (config) {
  config.url = config.url.replace(serverRoot + '@/', '')
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
ajax.interceptors.response.use(function (res) {
  if(res.status == 500){
    router.push('/500')
  }
  return Promise.resolve(res);
})
// Add a response interceptor
ajax.interceptors.response.use(filter, function (error) {
  return Promise.reject(error)
})
export default ajax



// WEBPACK FOOTER //
// ./src/http/index.js